<template>
	<div class="order">
		<table class='table table-condensed' style="border-collapse: initial">
			<tbody>
				<tr class="order-id-wrap">
					<td>Ärendenummer</td>
					<td class="id-number">{{ 'R' + serviceCase.id }}</td>
				</tr>
				<tr v-if="serviceCase.store" class="service-store">
					<td>
						Inlämnad till
					</td>
					<td>{{ serviceCase.store.name }}, {{  serviceCase.store.address }}</td>
				</tr>
				<tr v-if="events.length">
					<td colspan="2">
						Ärendestatus
						<div
							v-for="(event, index) in events"
							:key="'service-event-' + index"
						>
							<div class="d-flex">
								<div style="width: 116px;">
									{{ event.date }}
								</div>
								<div>
									<strong v-if="event.bold">{{ event.status }}</strong>
									<span v-else>{{ event.status }}</span>
								</div>
							</div>
							<hr v-if="index < events.length - 1" style="margin: 4px 0">
						</div>
					</td>
				</tr>
				<tr v-if="canOpenErrorModal" style="background-color: #f9f9f9">
					<td>
						Felbeskrivning
					</td>
					<td>
						<a @click="showError = true">
							{{ errorModalLabelText }}
						</a>
					</td>
				</tr>
				<modal v-model="showError" container-style="width: 600px">
					<div class="error-description">
						<div v-if="hasErrorDescription">
							<h3 class="mt-0">
								Felbeskrivning
							</h3>
							{{ serviceCase.errorDescription }}
						</div>
						<div v-if="hasActionTakenDescription">
							<h3>
								Åtgärd
							</h3>
							<ximg
								class="pull-left mr-4"
								:src="warehouseAvatarSrc"
								ariaLabel="warehouse worker"
								role="img"
							/>
							<span>{{ serviceCase.actionTakenDescription }}</span>
						</div>
						<div class="clearfix" />
					</div>
				</modal>
			</tbody>
		</table>
		<product-list-simple-item :product="serviceCase.product" />
		<div>
		</div>
		<table class="panel-footer order-footer">
			<tbody>
				<tr>
					<td class="d-flex">
						<ximg
							:src="speechBubbleIconSrc"
							ariaLabel="speechbubble"
							role="img"
						/>
						<a-link class="ml-4" :to="{ name: 'info', params: { id: 7, name: 'Kontakta oss'}, query: { caseId: 19, subCaseId: 22, ordernummer: serviceCase.orderId, arendenummer: serviceCase.id }}">
							Ställ en fråga om ärendet
						</a-link>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		serviceCase: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			showError: false,
		};
	},
	computed: {
		hasErrorDescription () {
			return this.serviceCase.errorDescription && this.serviceCase.errorDescription !== '';
		},
		hasActionTakenDescription () {
			return this.serviceCase.actionTakenDescription && this.serviceCase.actionTakenDescription !== '';
		},
		canOpenErrorModal () {
			if (! this.serviceCase.receivedDate) {
				return false;
			}
			return this.hasErrorDescription || this.hasActionTakenDescription;
		},
		errorModalLabelText () {
			let text = 'Visa';
			if (this.hasErrorDescription) {
				text += ' felbeskrivning';
			}
			if (this.hasErrorDescription && this.hasActionTakenDescription) {
				text += ' och';
			}
			if (this.hasActionTakenDescription) {
				text += ' åtgärd';
			}
			return text;
		},
		warehouseAvatarSrc () {
			return '/img/icons/avatar-gifs/lager2_76px.gif';
		},
		speechBubbleIconSrc () {
			return '/img/icons/info-pages/kontakta_oss.svg';
		},
		events () {
			const events = [];

			if (this.serviceCase.receivedDate) {
				events.push({
					date: this.serviceCase.receivedDate,
					status: 'Mottagen',
				});
			}
			if (this.serviceCase.sentDate) {
				events.push({
					date: this.serviceCase.sentDate,
					status: 'Skickat till verkstad',
				});
			}
			if (this.serviceCase.awaitingCostProposalDate) {
				events.push({
					date: this.serviceCase.awaitingCostProposalDate,
					status: 'Inväntar godkännande av kostnadsförslag',
				});
			}
			if (this.serviceCase.pickupReadyDate) {
				events.push({
					date: this.serviceCase.pickupReadyDate,
					status: 'Redo för utlämning',
				});
			}
			if (this.serviceCase.closedDate) {
				events.push({
					date: this.serviceCase.closedDate,
					status: 'Avslutad',
					bold: true,
				});
			}

			return events;
		},
	},
};
</script>